module.exports = __webpack_public_path__ + "static/img/1.db75236.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/1.png
// module id = RZ2W
// module chunks = 0